import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import axiosAuth from "../../../axiosAuth";
import { SCHOOL_INSTALLMENTS_BY_COMMERCIAL_ID } from "../../apiRoutes";

export interface SchoolInstallmentsResponse {
  data: unknown;
}

const fetchInstallmentsByCommercialId = async (commercialId: string) => {
  const response = await axiosAuth.get<SchoolInstallmentsResponse>(
    `${SCHOOL_INSTALLMENTS_BY_COMMERCIAL_ID}${commercialId}`
  );
  return response.data;
};

export const useGetInstallmentsByCommercialIdQuery = (
  commercialId: string,
  queryParams?: Omit<
    UseQueryOptions<
      SchoolInstallmentsResponse,
      Error,
      SchoolInstallmentsResponse,
      ["schoolInstallments", string]
    >,
    "queryKey" | "queryFn"
  >
) =>
  useQuery<
    SchoolInstallmentsResponse,
    Error,
    SchoolInstallmentsResponse,
    ["schoolInstallments", string]
  >({
    queryKey: ["schoolInstallments", commercialId],
    queryFn: () => fetchInstallmentsByCommercialId(commercialId),
    enabled: !!commercialId,
    ...(queryParams || {}),
  });


